import { render, staticRenderFns } from "./WorkingGroupAdd.vue?vue&type=template&id=b7665826&"
import script from "./WorkingGroupAdd.vue?vue&type=script&lang=js&"
export * from "./WorkingGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./WorkingGroupAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports